<div class="feedback">
    <p>
        Help us improve the product, send us feedback.
    </p>
    <button class="btn btn-primary" (click)="feedbackModal.show()">Feedback</button>
</div>

<div class="modal fade" bsModal #feedbackModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">Send us some feedback</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="feedbackModal.hide()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s.</p>
                <textarea placeholder="Enter feedback here."></textarea>
            </div>
            <div class="modal-footer">
                <div class="col-12 text-align-right">
                    <button class="btn btn-primary" (click)="feedbackModal.hide()">Send Feedback</button>
                </div>
            </div>
        </div>
    </div>
</div>